<template>
  <v-main class="third">
    <v-container class="px-6 fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col
          cols="12"
          sm="6"
          md="4"
        >
          <v-card flat class="pa-6">
            <v-row class="pb-4" justify="center">
              <v-img
                src="../assets/fiemslogo.png"
                height="220"
                width="220"
                contain
              ></v-img>
            </v-row>
            <div class="py-2 primary--text">UserName</div>
            <div>
              <v-text-field
                v-model="email"
                solo
                rounded
                dense
                class="text-color"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary">mdi-account-outline</v-icon>
                </template>
              </v-text-field>
            </div>
            <div class="pb-2 primary--text">Password</div>
            <div>
              <v-text-field
                v-model="password"
                solo
                dense
                rounded
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                class="text-color"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary">mdi-lock-outline</v-icon>
                </template>
              </v-text-field>
            </div>
            <div class="py-4">
              <v-btn
                block
                rounded
                large
                color="primary"
                @click="onLogin"
              >LOGIN</v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        top
        color="error"
      >
        {{ message }}
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import LoginService from '../services/LoginService'
import axios from 'axios'
export default {
  name: 'Login',
  data () {
    return {
      show1: false,
      email: '',
      password: '',
      error: null,
      message: null,
      snackbar: false,
      timeout: 4000
    }
  },
  methods: {
    async onLogin () {
      const login = {
        email: this.email,
        password: this.password
      }

      /* await LoginService.login(login, (err, res) => {
        if (err) {
          console.log(err.response)
          this.error = err.message
          this.snackbar = true
        }
        if (res) {
          console.log(res)
          this.$store.dispatch('setAdminToken', res.data.token)
          this.$store.dispatch('setAdmin', res.data.admin)
          this.$router.push('/')
        }
      }) */
      await LoginService.login(login).then((res) => {
        // console.log(res)
        if (res.status === 200) {
          axios.defaults.headers.Authorization = `Bearer ${res.data.token}`
          this.$store.dispatch('setAdmintoken', res.data.token)
          this.$store.dispatch('setAdmin', res.data.admin)
          this.$router.push('/')
        }
      }).catch((err) => {
        // console.log(err.response)
        if (err.response.status === 403) {
          this.message = err.response.data.error
          this.snackbar = true
        } else {
          this.message = err.response.data.title
          this.snackbar = true
        }
      })
    }
  }
}
</script>

<style>
.v-main {
  height: 100%
}
.text-color .v-text-field__slot input {
  color: #0D8134 !important
}
</style>
